import "./TimeRangeSelector.scss";

import React, { useCallback, useContext } from "react";

import MenuTrigger from "../../nav/MenuTrigger/MenuTrigger";
import MenuDropdown from "../../nav/MenuDropdown/MenuDropdown";
import Text from "../../common/Text/Text";
import { IconCalender } from "../../../assets";
import * as PillarDataUtils from "../../../lib/util/PillarDataUtils";
import { TimeSelection } from "../../../lib/util/PillarDataUtils";
import { TrackingContext } from "../../../lib/util/AnalyticsUtils";
import * as StorageUtils from "../../../lib/util/StorageUtils";

export interface TimeRangeSelectorProps {
	onChange?: (selection: TimeSelection) => void;
	defaultValue?: string;
	value?: string;
	options?: Array<TimeSelection>;
	storageKey?: StorageUtils.StorageKey<string>;
}

const TimeRangeSelector = (props: TimeRangeSelectorProps) => {
	let { onChange, defaultValue, options, value, storageKey } = props;
	const trackingContext = useContext(TrackingContext);

	if (!options) {
		options = Object.values(PillarDataUtils.TIME_SELECTION);
	}

	const currentValue = value || defaultValue;
	const selected = options.find((opt) => opt.id === currentValue);
	const mixpanelEvtName = "Time Range Selector";

	const handleChange = useCallback(
		(selection) => {
			if (storageKey) {
				StorageUtils.set(storageKey, selection.id);
			}

			if (onChange) {
				onChange(selection);
			}
		},
		[storageKey, onChange],
	);

	const newContext =
		typeof trackingContext === "string"
			? {
					ga: trackingContext,
					mixpanel: { name: mixpanelEvtName },
			  }
			: {
					...trackingContext,
					mixpanel: {
						...trackingContext.mixpanel,
						name: mixpanelEvtName,
					},
			  };

	return (
		<TrackingContext.Provider value={newContext}>
			<MenuDropdown
				className={"TimeRangeSelector --pdf-ignore"}
				items={options}
				overlay={true}
				usePortal={true}
				selected={currentValue}
				onSelect={handleChange}
			>
				<MenuTrigger className={"TimeRangeSelector__trigger"}>
					<IconCalender className={"TimeRangeSelector__icon"} />
					<Text>{selected?.displayName}</Text>
				</MenuTrigger>
			</MenuDropdown>
		</TrackingContext.Provider>
	);
};

export default TimeRangeSelector;
